import { render, staticRenderFns } from "./CertifyEmail.vue?vue&type=template&id=d6c32a50&scoped=true&"
import script from "./CertifyEmail.vue?vue&type=script&lang=js&"
export * from "./CertifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./CertifyEmail.vue?vue&type=style&index=0&id=d6c32a50&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d6c32a50",
  null
  
)

export default component.exports